import { Radio } from "antd"
import styled from "styled-components"

const RadioStyle = styled(Radio)`
  .ant-radio-inner {
    border-color: ${(props) => props.theme.colorbluegrey};
    border-width: 2px;
    background-color: transparent;
  }
  .ant-radio-checked {
    border-color: ${(props) => props.theme.primary};
    background-color: transparent;
    .ant-radio-inner {
      border-color: ${(props) => props.theme.primary};
      background-color: transparent;
      &::after {
        background-color: ${(props) => props.theme.primary};
      }
    }
  }
`
export default RadioStyle
